import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from '../api/api.service';
import {
  XmeAccessIds,
  XmeRequestVerificationsResponse,
  XmeSearchResponse,
  XmeStopResponse,
  XmeViewerSessionResponse,
} from './xme.model';

@Injectable({
  providedIn: 'root'
})
export class XmeService {
  path = 'xme/';

  constructor(
    private apiService: ApiService
  ) { }

  search(query: string): Observable<XmeSearchResponse> {
    return this.apiService
      .post(this.path + 'search', { query })
      .pipe(map(res => res['data']));
  }

  requestVerifications(query: string, xmeUserId?: string | null): Observable<XmeRequestVerificationsResponse> {
    const body: { query: string; xme_user_id?: string } = { query };
    if (xmeUserId) {
      body.xme_user_id = xmeUserId;
    }
    return this.apiService
      .post(this.path + 'request-verifications', body)
      .pipe(map(res => res['data']));
  }

  viewerSession(ids: XmeAccessIds): Observable<XmeViewerSessionResponse> {
    return this.apiService
      .post(this.path + 'viewer-session', this.accessBody(ids))
      .pipe(map(res => res['data']));
  }

  stop(ids: XmeAccessIds): Observable<XmeStopResponse> {
    return this.apiService
      .post(this.path + 'stop', this.accessBody(ids))
      .pipe(map(res => res['data']));
  }

  private accessBody(ids: XmeAccessIds): { person_uid?: string; xme_access_uid?: string } {
    const body: { person_uid?: string; xme_access_uid?: string } = {};
    if (ids.person_uid) {
      body.person_uid = ids.person_uid;
    }
    if (ids.xme_access_uid) {
      body.xme_access_uid = ids.xme_access_uid;
    }
    return body;
  }
}
